module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shown) ? _c('div', {
    staticClass: "pp-mobile-plays"
  }, [(_vm.plays > 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.plays) + " free tracks remaining\n    ")]) : _c('span', [_vm._v("\n        Out of free tracks.\n    ")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fbb0942","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileFreePlays.vue
// module id = 173
// module chunks = 0